import { merge } from 'highed';
import { cloneDeep } from 'lodash';

export const getAggregatedOptions = (projectConfig) =>
  merge(cloneDeep(projectConfig.themeOptions.options), cloneDeep(projectConfig.customizedOptions));
